import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import COLOR from "./../../Style";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isSessionSuccess } from "../../StateManagement/sessionSlice";
import menulist from "./../../components/users/MenuComponent/menulist.json";
import Background from "../../components/general/Background";
import { Container } from "@material-ui/core";

export default function WelcomeTryoutNewDesign() {
  const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      "@media (min-width:600px)": {
        flexDirection: "row",
      },
    },
    greetingContainer: {
      fontSize: 16,
      fontWeight: 500,
      paddingTop: 20,
      "@media (min-width:600px)": {
        width: "30%",
        paddingTop: 80,
      },
    },
    menuContainer: {
      paddingTop: 20,
      "@media (min-width:600px)": {
        width: "70%",
        paddingTop: 80,
      },
    },
    greeting: {
      fontSize: 20,
      fontWeight: 500,
      fontFamily: "bungeeregular",
      lineHeight: 1.2,
      marginBottom: 16,
    },
    underlined: {
      textDecoration: "underline",
      textDecorationThickness: 0.5,
      textUnderlineOffset: "8px",
    },
  });
  const classes = useStyles();
  const username = useSelector((state) => state.session.session.username);

  useEffect(() => {
    return;
  }, [username]);

  return (
    <Background>
      <Container maxWidth="lg">
        <div className={classes.container}>
          <div className={classes.greetingContainer}>
            <p>Hai</p>
            <p className={classes.greeting}>
              Selamat Datang,{" "}
              <span className={classes.underlined}>{username}</span>{" "}
            </p>
            <p>Pilih Materi Belajarmu</p>
          </div>
          <div className={classes.menuContainer}>
            <Title />
            <WelcomeTryout />
          </div>
        </div>
      </Container>
    </Background>
  );
}

function Title({ subjectId = "TRY OUT" }) {
  const title = String(subjectId).toUpperCase();
  const icon = React.useMemo(
    () =>
      menulist.filter((m) => m.title === String(subjectId).toUpperCase())[0]
        ?.icon.normal,
    [subjectId]
  );
  const info = React.useMemo(
    () =>
      menulist.filter((m) => m.title === String(subjectId).toUpperCase())[0]
        ?.info,
    [subjectId]
  );

  const classes = makeStyles({
    container: {
      width: "100%",
      height: 80,
      borderRadius: 8,
      padding: 8,
      display: "flex",
      backgroundColor: "#ec87b3",
      "@media (min-width:600px)": {
        width: "60%",
      },
      "@media (min-width:800px)": {
        width: "40%",
      },
    },
    icon: {
      minWidth: 40,
      height: 40,
      background: `url(${icon})`,
      backgroundRepeat: "no-repeat",
      backgroundPositionY: 0,
      backgroundPositionX: "center",
      backgroundSize: "30px 30px",
    },
    content: {
      paddingLeft: 8,
      fontSize: 12,
      "@media (min-width:800px)": {
        fontSize: 14,
      },
    },
    title: {
      fontWeight: 800,
      marginBottom: 8,
      fontSize: 18,
    },
  })();

  return (
    <div className={classes.container}>
      <div className={classes.icon}></div>
      <div className={classes.content}>
        <p className={classes.title}>{title}</p>
        <p>{info}</p>
      </div>
    </div>
  );
}

function WelcomeTryout() {
  const useStyles = makeStyles({
    container: {
      color: COLOR.coklatTua,
      display: "flex",
      width: "100%",
      marginTop: 10,
      flexDirection: "column",
      "@media (min-width:600px)": {
        width: "60%",
      },
      "@media (min-width:800px)": {
        width: "40%",
      },
    },
    item: {
      backgroundColor: "#fff",
      color: "#140c41",
      fontWeight: 600,
      marginBottom: 8,
      padding: "8px 20px",
      borderRadius: 10,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#140c41",
        color: "#fff",
      },
    },
    link: {
      cursor: "pointer",
      fontWeight: 600,
      "&:hover": {
        textDecoration: "underline",
      },
    },
    notif: {
      marginTop: 10,
      textAlign: "center",
      padding: 20,
    },
  });

  const classes = useStyles();
  const history = useHistory();
  const isLoggedIn = useSelector(isSessionSuccess);

  return (
    <div className={classes.container}>
      {isLoggedIn ? (
        <>
          <div
            className={classes.item}
            onClick={() => history.push("/product/tryout")}
          >
            Beli Tiket Try Out
          </div>
          <div className={classes.item} onClick={() => history.push("/tryout")}>
            Kerjakan Try Out
          </div>
        </>
      ) : (
        <>
          <div
            className={classes.link}
            onClick={() => history.push("/login?redirect=welcome-tryout")}
          >
            Log In ke Aplikasi
          </div>
          <div className={classes.notif}>
            *Silakan Login terlebih dahulu untuk membeli tiket try out.{" "}
            <a href="/pendaftaran">klik untuk daftar akun</a>.
          </div>
        </>
      )}
    </div>
  );
}
